import { IApplicationState } from '@Site/rootReducer'

export const getHasLoadedUserDataSuccessfully = (state: IApplicationState): boolean => state.user.hasLoadedSuccessfully

export const getHasUpdatedProfileSuccessfully = (state: IApplicationState): boolean => state.user.hasUpdatedProfileSuccessfully

export const getSaving = (state: IApplicationState): boolean => state.user.saving

export const getHasConfirmedEmail = (state: IApplicationState): boolean => state.user.user.attributes.confirmedEmail

export const getUserId = (state: IApplicationState): number => state.user.user.id

export const getUserRole = (state: IApplicationState): string => state.user.user.attributes.role

export const getUserHasSelectedRole = (state: IApplicationState): boolean => state.user.user.attributes.hasSelectedRole

export const getUserEmail = (state: IApplicationState): string => state.user.user.attributes.email

export const getUserName = (state: IApplicationState): string => state.user.user.attributes.name || ''

export const getUserLastName = (state: IApplicationState): string => state.user.user.attributes.lastName || ''

export const getUserAvatarUrl = (state: IApplicationState): string | undefined => state.user.user.attributes.avatarUrl

export const getLastUsedAccountId = (state: IApplicationState): number => typeof(state.user.user.attributes.lastUsedAccountId) === 'number' ? state.user.user.attributes.lastUsedAccountId : -1

export const getLastUsedWorkspaceId = (state: IApplicationState): number => typeof(state.user.user.attributes.lastUsedWorkspaceId) === 'number' ? state.user.user.attributes.lastUsedWorkspaceId : -1

export const getNumberOfProjectsSuccessfullyCreated = (state: IApplicationState): number => state.user.user.attributes.numberOfProjectsSuccessfullyCreated

export const getShouldSeeNewsletterPopup = (state: IApplicationState): boolean => state.user.user.attributes.shouldSeeNewsletterPopup

export const getUseLightTheme = (state: IApplicationState): boolean => state.user.useLightTheme

export const getErrorMessageCurrentPasswordForNewEmail = (state: IApplicationState): string | null => state.user.errorMessageCurrentPasswordForNewEmail

export const getErrorMessageCurrentPasswordForNewPassword = (state: IApplicationState): string | null => state.user.errorMessageCurrentPasswordForNewPassword

export const getUploadingAvatar = (state: IApplicationState) => state.user.uploadingAvatar

export const getFirstProjectType = (state: IApplicationState) => state.user.user.attributes.firstProjectType
